<div
    class="cm-viewer-container"
    [class.cm-grab]="!$allowSelect()"
    (mousedown)="$onboardingHintVisible() ? hideOnboardingIcons() : null"
    (touchstart)="$onboardingHintVisible() ? hideOnboardingIcons() : null"
>
    @if ($runningOperation() !== "none") {
        <cm-custom-loading-screen
            [backgroundImageUrl]="$customLoadingScreen().backgroundImageUrl"
            [loadingSpinnerSvgUrl]="$customLoadingScreen().loadingSpinnerSvgUrl"
            [showSpinner]="$customLoadingScreen().showSpinner"
        >
            <ng-container cm-text-bottom>
                @switch ($runningOperation()) {
                    @case ("gltf") {
                        Generating glTF...
                    }
                    @case ("stl") {
                        Generating STL files...
                    }
                    @case ("ar") {
                        Generating AR model...
                    }
                }
            </ng-container>
        </cm-custom-loading-screen>
    }
    @if ($onboardingHintVisible() && $runningOperation() === "none") {
        <cm-onboarding-hint></cm-onboarding-hint>
    }

    <cm-three-template-scene-provider (onInitialized)="onInitializedThreeSceneManagerService($event)" [pixelRatio]="$pixelRatio()" [forceWebGl]="$forceWebGl()">
        <!--Structural directives like @if create embedded views, which have a different destruction order than regular projected content.
            Angular destroys embedded views before calling the host component's ngOnDestroy.
            We leverage this here to destroy all children before the cm-three-template-scene-provider.
            This is particularly important for <cm-three-template-scene-viewer> destroying before ThreeSceneManagerService.-->
        @if ($isAlive()) {
            <cm-three-template-scene-viewer
                #viewer
                [allowSelect]="$allowSelect()"
                [camera]="$camera()"
                [allowEdit]="false"
                [previewImageData]="$previewImageData()"
                [overlayPreviewImageData]="$overlayPreviewImageData()"
            ></cm-three-template-scene-viewer>
            @if ($configChangeOverlay(); as snapshot) {
                <div
                    class="cm-config-change-overlay"
                    [class.cm-fading-out]="!$configChangeOverlayVisible()"
                    (transitionend)="onConfigChangeOverlayTransitionEnd($event)"
                >
                    <img alt="" [src]="snapshot" />
                    @if ($configChangeOverlayVisible()) {
                        <cm-custom-loading-screen
                            class="cm-config-change-spinner"
                            [loadingSpinnerSvgUrl]="$customLoadingScreen().loadingSpinnerSvgUrl"
                            [showSpinner]="true"
                            [transparent]="true"
                        ></cm-custom-loading-screen>
                    }
                </div>
            }
            @if ($showDebugMenu()) {
                <cm-debug-menu
                    class="cm-debug-menu"
                    [threeViewer]="viewer"
                    (previewImageDataChanged)="$previewImageData.set($event)"
                    (overlayPreviewImageDataChanged)="$overlayPreviewImageData.set($event)"
                ></cm-debug-menu>
            }
            @if ($showUi() && $runningOperation() !== "loading") {
                <cm-action-menu
                    class="cm-action-menu"
                    [inFullscreen]="$inFullscreen()"
                    [fullscreenEnabled]="localSceneManagerService.$sceneOptions()?.enableFullscreen ?? true"
                    [stlDownloadEnabled]="localSceneManagerService.$sceneOptions()?.enableStlDownload ?? false"
                    [gltfDownloadEnabled]="localSceneManagerService.$sceneOptions()?.enableGltfDownload ?? false"
                    [snapshotEnabled]="localSceneManagerService.$sceneOptions()?.enableSnapshot ?? true"
                    [arEnabled]="localSceneManagerService.$sceneOptions()?.enableAr ?? false"
                    [pdfEnabled]="$pdfEnabled()"
                    [enableDimensionGuides]="localSceneManagerService.$sceneOptions()?.enableDimensionGuides ?? false"
                    [dimensionGuidesActive]="localSceneManagerService.$showDimensionGuides()"
                    [organizationId]="$organizationId()"
                >
                    <ng-container cm-action-menu-additional>
                        <ng-content select="[cm-action-menu-additional]"></ng-content>
                    </ng-container>
                </cm-action-menu>
                @if ($showMenu()) {
                    <cm-config-menu
                        class="cm-config-menu"
                        exportparts="cm-config-group-title, cm-config-group-title-active, cm-config-menu-icons, cm-icon-container, cm-icon-with-caption, cm-icons-container, cm-labels-container, cm-mobile-tabs-groups, cm-scroll-arrow, cm-scroll-arrow-left, cm-scroll-arrow-right"
                    ></cm-config-menu>
                }
            }
        }
    </cm-three-template-scene-provider>
</div>
